<template>
  <StackLayout class="wrapper">
    <AgCard modal avatar :caption="caption">
      <AgAvatar slot="avatar">
        <AgIcon :type="icon" size="50" />
      </AgAvatar>
      <FlexboxLayout class="step card-text" v-for="(entry, index) in steps" :key="index" alignItems="center">
        <AgIcon v-if="entry.icon" :type="entry.icon" size="100" />
        <Label :text="entry.title" textWrap />
      </FlexboxLayout>
      <StackLayout class="card-content">
        <AgButton text="Weiter" @tap="close" @click="close" />
      </StackLayout>
    </AgCard>
  </StackLayout>
</template>

<script>

export default {
  props: {
    type: {
      type: String
    }
  },
  data: () => ({
    step: 0
  }),
  computed: {
    steps () {
      let entries = []

      if (this.type === 'capture') {
        entries.push({
          title: 'Rechnung nicht durch Kassenbelege oder sonstiges verdecken',
          icon: 'agila:captureAvoidCovering'
        })
        
        entries.push({
          title: 'Keine Knicke oder Falten im Papier',
          icon: 'agila:captureDoNotBend'
        })
        
        entries.push({
          title: 'Lichtverhältnisse und Lesbarkeit prüfen',
          icon: 'agila:captureLightingAndLegibility'
        })
      }

      return entries
    },
    caption () {
      if (this.type === 'capture') {
        return '3 Tipps zum perfekten Bild Ihres Dokuments'
      }

      return this.type
    },
    icon () {
      if (this.type === 'capture') {
        return 'agila:captureInvoice'
      }

      return this.type
    }
  },
  methods: {
    close () {
      this.$emit('done')
    }
  }
}

</script>

<style scoped lang="scss">

html {
  .step {
    font-size: 18px;
    font-weight: bold;
    padding: 20px;

    .icon {
      margin-right: 20px;
    }
  }
}

.ns-ios,
.ns-android {
  .step {
    font-size: 18px;
    font-weight: bold;
    padding: 20;

    .icon {
      margin-right: 20;
    }
  }
}
</style>